// Types
import Vue from"vue";const LoginView=Vue.extend({name:"LoginView",render(){const a=arguments[0];return a("div",["Login"])}});export default LoginView;